var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.globalLoading && !_vm.globalError
        ? _c(
            "div",
            { staticClass: "el-centered eu-fade-in" },
            [_c("emd-pagarme-loader", { attrs: { color: "secondary" } })],
            1
          )
        : _vm._e(),
      !_vm.globalLoading && _vm.globalError
        ? _c(
            "div",
            { staticClass: "app-error-wrapper" },
            [
              _c("logo-stone-rebrand", {
                staticClass: "app-error-wrapper__logo",
              }),
              _c("global-error", {
                attrs: { theme: "pagarme", showLogo: false, code: _vm.code },
              }),
            ],
            1
          )
        : !_vm.globalLoading && !_vm.globalError
        ? [_c("router-view")]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }